import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsentComponent } from '../components/consent-input/consent.component';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorComponent } from 'src/app/components/error/error.component';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [ConsentComponent, LoaderComponent, ErrorComponent],
  exports: [ConsentComponent, LoaderComponent, ErrorComponent, CommonModule, TranslateModule]
})
export class SharedModule {}
